<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2, getScreen } from '../../Reusable/O3DG2'
import { PlaneBufferGeometry, MeshBasicMaterial, Mesh } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
    setup () {
      let mat = new MeshBasicMaterial({ color: 0x2a2a2a, opacity: 0.8, transparent: true, depthWrite: false })
      let mesh = new Mesh(undefined, mat)

      mesh.userData.noHover = true
      this.ctx.rayplay.add(mesh, () => {})

      this.onResize(() => {
        let screen = getScreen({ camera: this.ctx.camera, depth: this.o3d.position.z })
        let screenHeight = screen.height
        let innerHeight = window.innerHeight
        let px = screenHeight / innerHeight
        let geo = new PlaneBufferGeometry(screen.width, 56 * px, 2, 2)
        geo.translate(0, 56 * px * 0.5, 0.01)
        mesh.geometry = geo
      })
      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>